export interface UserState {
    companyData: {};
    inProgress?: boolean;
    error?: any;
    notify?: boolean,
    isCompChange?: boolean
}
export enum UserActionTypes {
    ADD_ACTIVE_COMPANY_REQUEST = 'ADD_ACTIVE_COMPANY_REQUEST',
    ADD_ACTIVE_COMPANY_SUCCESS = 'ADD_ACTIVE_COMPANY_SUCCESS',
    ADD_ACTIVE_COMPANY_ERROR = 'ADD_ACTIVE_COMPANY_ERROR',
}

interface SetCompanyRequestAction {
    type: UserActionTypes.ADD_ACTIVE_COMPANY_REQUEST
}

interface SetCompanySuccessAction {
    type: UserActionTypes.ADD_ACTIVE_COMPANY_SUCCESS;
    payload: any;
}
interface SetCompanyErrorAction {
    type: UserActionTypes.ADD_ACTIVE_COMPANY_ERROR;
    error: any;
}

export type UserAction =
     SetCompanyRequestAction |
     SetCompanySuccessAction |
     SetCompanyErrorAction 
 
